<template>
  <div id="mevConfig">
    <PageTitle :title="$t('mev_config.title')" :subtitle="$t('mev_config.subtitle')"></PageTitle>

    <PageContainer>
      <MevSettings v-if="haveMevConfiguration && mevConfig" ref="mevSettings" :mevConfig="mevConfig" :validate="$validate" @saveConfig="save"/>
    </PageContainer>

    <PageFooter :mainAction="{action: saveConfig, text: $t('save')}"></PageFooter>
  </div>
</template>

<script>
import PageTitle from "@/components/PageTitle";
import PageContainer from "@/components/PageContainer";
import PageFooter from "@/components/PageFooter";
import {mapActions} from "vuex";
import MevSettings from "@/components/pos/MevSettings";

export default {
  name: "MevConfig",

  components: { PageTitle, PageContainer, PageFooter, MevSettings },

  data() {
    return {
      company: null,
      mevConfig: null,
    }
  },

  async mounted() {
    this.$store.state.pageTitleTranslationKey = "mev_config.title";
    this.$store.state.pageIcon = "/icon/setting.svg";

    showSpinner();
    await this.loadCompany();
    hideSpinner();
  },

  computed: {
    companyId() {
      return this.$route.query.company;
    },
    branchId() {
      return this.$route.query.branch;
    },
    haveMevConfiguration() {
      return this.company && this.company.country === "CA" && this.company.region === "QC";
    }
  },

  methods: {
    ...mapActions(["getCompany", "saveCompany"]),

    async loadCompany() {
      let response = await this.getCompany({
        branchId: this.branchId,
        companyId: this.companyId,
        augment: "backend"
      });
      if (response) {
        this.company = response;
        if (response.mevConfig) {
          this.mevConfig = response.mevConfig;
        } else {
          this.mevConfig = {
            registeredName: "",
            identificationNumber: "",
            orgName: "",
            orgUnit: "",
            billingFileNumber: "",
            civicNumber: "",
            postalCode: "",
            timeoutForOffline: ""
          }
        }
      }
    },

    async save() {
      //TODO validate according to MEV standard for characters in string and validate value formatting.
      let data = {
        mevConfig: this.mevConfig
      };
      showSpinner();
      let response = await this.saveCompany({
        branchId: this.branchId,
        companyId: this.companyId,
        data: data
      });
      hideSpinner();
      if (response) {
        toast(this.$t("mev_config.saveSuccess"), "success", this.$t("success"));
      } else {
        toast(this.$t("mev_config.saveError"), "error", this.$t("error.title"));
      }
    },
    saveConfig() {
      //call validate of setting
      if (this.$refs && this.$refs.mevSettings) {
        this.$refs.mevSettings.validateAndSave();
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>